import { render, staticRenderFns } from "./body-schedules.vue?vue&type=template&id=096372e7&scoped=true"
import script from "./body-schedules.vue?vue&type=script&lang=js"
export * from "./body-schedules.vue?vue&type=script&lang=js"
import style0 from "./body-schedules.vue?vue&type=style&index=0&id=096372e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096372e7",
  null
  
)

export default component.exports